import { get, post, postfd } from '@/utils/request1';

export const usersInfo = (data) => post('user/user_info',data); // 会员信息
export const usersUpdate = (data) => post('user/profile',data); // 修改用户信息
export const passEdit = (data) => post('user/resetpwd',data); // 修改密码
export const uploadAvatar = (data) => postfd('user/upload_avatar',data); // 上传头像（FormData：file + user_code）
